export const GET_CMS_BANNER = "GET_CMS_BANNER";
export const GET_CMS_BANNER_ERROR = "GET_CMS_BANNER_ERROR";